import { compareGridIndexes } from "./catalogColumns";

export const GROUP_THEME_KEYS = ["sky", "mint", "amber", "rose", "violet", "teal"];

const isValidThemeKey = (key) => GROUP_THEME_KEYS.includes(key);

/** Stable palette slot from group id (does not change when order/column changes). */
export const themeKeyFromGroupId = (id, fallbackIndex = 0) => {
  if (id == null) {
    return GROUP_THEME_KEYS[fallbackIndex % GROUP_THEME_KEYS.length];
  }
  const numeric = Number(id);
  if (Number.isFinite(numeric)) {
    return GROUP_THEME_KEYS[Math.abs(numeric) % GROUP_THEME_KEYS.length];
  }
  let hash = 0;
  const str = String(id);
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash + str.charCodeAt(i)) % GROUP_THEME_KEYS.length;
  }
  return GROUP_THEME_KEYS[hash];
};

export const resolveGroupThemeKey = (group, fallbackIndex = 0) => {
  if (group?.themeKey && isValidThemeKey(group.themeKey)) return group.themeKey;
  return themeKeyFromGroupId(group?.id, fallbackIndex);
};

/** One-time theme assignment from API sort order (before any drag). */
export const buildInitialThemeMap = (groups = []) => {
  const sorted = [...groups].sort((a, b) =>
    compareGridIndexes(a.index, b.index)
  );
  const map = {};
  sorted.forEach((group, index) => {
    map[String(group.id)] = resolveGroupThemeKey(group, index);
  });
  return map;
};

export const applyThemeMapToColumns = (columns, themeById = {}) =>
  columns.map((col) =>
    col.map((group) => {
      if (group == null) return null;
      const themeKey =
        themeById[group.id] ??
        themeById[String(group.id)] ??
        resolveGroupThemeKey(group);
      return {
        ...group,
        themeKey,
      };
    })
  );
